
import React, { useState } from 'react'
import DateNcity from '../../components/Filters/DateNcity'
import { useAgency } from './agencyApis'

export default function RealEstateAgency() {
  const allAgenciesResult = useAgency((state) => state.allAgenciesResult)
  const allAgenciesPagination = useAgency((state) => state.allAgenciesPagination)
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [selectedAgencyID, setSelectedAgencyID] = useState(null);

  const openEditAgencyModalHandler = (agency) => {
    setSelectedAgency(agency)
  }
  const deleteAgencyHandler = async (agency) => {
    // console.log(ID, "ID in deleteHandler");

    // await deleteAgency(ID)
    setSelectedAgencyID(agency?.id)
    // setSelectedAgency(agency)
  }
  return (
    <div  className='mb-[50px]'>
      <div>
        { allAgenciesPagination.currentPage }
      </div>
      <p className='text-center text-[20px] font-bold mb-4'>مشاورین املاک</p>
      <DateNcity isInRealEstateAgencyPage={true} selectedAgency={selectedAgency} selectedAgencyID={selectedAgencyID} />
      <div className='rounded-xl border border-gray-300 w-full mt-4 overflow-hidden'>
        <table class="table-auto border-collapse w-full ">
          <thead className='rounded-xl'>
            <tr className='bg-[#B9B9B9] '>
              <th class="border border-gray-300 p-2">ردیف  </th>
              <th class="border border-gray-300 p-2">نام آژانس املاک  </th>
              <th class="border border-gray-300 p-2">شماره آژانس املاک  </th>
              <th class="border border-gray-300 p-2">شناسه صنفی  </th>
              <th class="border border-gray-300 p-2">آدرس  </th>
              <th class="border border-gray-300 p-2">نام و نام خانوادگی  مدیر</th>
              <th class="border border-gray-300 p-2">شماره همراه مدیر </th>
              <th class="border border-gray-300 p-2"> استان / شهر/منطقه  </th>
              <th class="border border-gray-300 p-2">نام و نام خانوادگی منشی  </th>
              <th class="border border-gray-300 p-2">شماره منشی  </th>
              <th class="border border-gray-300 p-2">  </th>
            </tr>
          </thead>
          <tbody>
            {allAgenciesResult?.map((agency, index) =>
            (

              <tr key={agency?.id}>
                <td class="border border-gray-300 p-2">
                  { ((allAgenciesPagination.currentPage - 1) * allAgenciesPagination?.perPage) + index + 1 }
                </td>
                <td class="border border-gray-300 p-2">{agency?.agancyTitle}</td>
                <td class="border border-gray-300 p-2">{agency?.agancyPhone}</td>
                <td class="border border-gray-300 p-2">{agency?.guildCode}</td>
                <td class="border border-gray-300 p-2">{agency?.address}</td>
                <td class="border border-gray-300 p-2" >{agency?.firstName} {agency?.lastName}</td>
                <td class="border border-gray-300 p-2" >{agency?.mobile}</td>
                <td class="border border-gray-300 p-2">
                  {agency?.state?.locName}
                  {agency?.city?.locName && ` / ${agency.city.locName}`}
                  {agency?.area?.locName && ` / ${agency.area.locName}`}
                </td>
                <td class="border border-gray-300 p-2" >{agency?.secretaryName}</td>
                <td class="border border-gray-300 p-2" >{agency?.secretaryMobile}</td>
                <td class="border border-gray-300 p-2 flex justify-between" >
                  <img
                    src='/icons/edit-02.svg'
                    alt='edit icon'
                    className='cursor-pointer'
                    onClick={() => openEditAgencyModalHandler(agency)}
                  />
                  <img src='/icons/trash-02.svg'
                    alt='trash icon'
                    className='cursor-pointer'
                    onClick={() => deleteAgencyHandler(agency)}
                  />

                </td>
              </tr>)
            )}
          </tbody>
        </table>
        <>
        </>
      </div>
    </div>
  )
}
